import PropTypes from "prop-types";
import React from "react";
import {
  Alert,
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
  Spinner,
} from "reactstrap";
//redux
import { useDispatch } from "react-redux";

import { Link } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";

// Formik Validation
import { useFormik } from "formik";
import * as Yup from "yup";

// action
import { forgetPassword } from "../../slices/thunks";

// import images
// import profile from "../../assets/images/bg.png";
import Swal from "sweetalert2";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
import { PrimaryLogo } from "../../Components/Logo/PrimaryLogo";
import { useCustomTheme } from "../../slices/theme/hooks";
import { DocumentTitle } from "../../Components/Common/DocumentTitle";

const ForgetPasswordPage = (props) => {
  const dispatch = useDispatch();

  const [loading, setLoading] = React.useState(false);
  const customTheme = useCustomTheme();

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your Email"),
    }),
    onSubmit: async (values) => {
      setLoading(true);

      dispatch(forgetPassword(values.email, props.history))
        .then((result) => {
          setLoading(false);
          if (result && result.success) {
            Swal.fire({
              title: "Success!",
              text: "Reset link has been sent to your mailbox, please check your email",
              icon: "success",
              confirmButtonText: "Ok",
            });
          }
        })
        .catch((error) => {
          setLoading(false);
          console.error("Forget password error:", error);
          Swal.fire({
            title: "Error!",
            text: error?.message || "Failed to send reset link. Please try again.",
            icon: "error",
            confirmButtonText: "Ok",
          });
        });
    },
  });


  return (
    <ParticlesAuth>
      <div className="auth-page-content">
        <Container>
          <Row>
            <Col lg={12}>
              <div
                style={{
                  width: 'max-content', alignSelf: 'center',
                  margin: '0 auto',
                  borderRadius: '0.5rem',
                  backgroundColor: customTheme?.secondaryColor
                }}
                className="text-center my-2 mb-4 p-3 d-flex align-items-center" >
                <PrimaryLogo />
              </div>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="mt-4">
                <CardBody className="p-4">
                  <div className="text-center mt-2">
                    <h5 className="text-primary">Forgot Password?</h5>

                    <lord-icon
                      src="https://cdn.lordicon.com/rhvddzym.json"
                      trigger="loop"
                      colors="primary:#0ab39c"
                      className="avatar-xl"
                      style={{ width: "120px", height: "120px" }}
                    ></lord-icon>
                  </div>

                  <Alert
                    className="alert-borderless alert-warning text-center mb-2 mx-2"
                    role="alert"
                  >
                    Enter your email and instructions will be sent to you!
                  </Alert>
                  <div className="p-2">
                    {/* {forgetError && forgetError ? (
                      <Alert color="danger" style={{ marginTop: "13px" }}>
                        {forgetError}
                      </Alert>
                    ) : null}
                    {forgetSuccessMsg ? (
                      <Alert color="success" style={{ marginTop: "13px" }}>
                        {forgetSuccessMsg}
                      </Alert>
                    ) : null} */}
                    <Form
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      <div className="mb-4">
                        <Label className="form-label">Email</Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Enter email"
                          type="email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            validation.touched.email && validation.errors.email
                              ? true
                              : false
                          }
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid">
                            <div>{validation.errors.email}</div>
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="text-center mt-4">
                        <Button
                          color="primary"
                          disabled={loading ? true : false}
                          className="btn btn-primary w-100"
                          type="submit"
                        >
                          {loading ? (
                            <Spinner size="sm" className="me-2">
                              {" "}
                              Loading...{" "}
                            </Spinner>
                          ) : null}
                          Send Reset Link
                        </Button>
                        {/* <button
                          className="btn btn-primary w-100"
                          type="submit"
                          disabled={loading}
                        >
                          {loading ? (
                            <Spinner color="light" size="sm" />
                          ) : (
                            "Send Reset Link"
                          )}
                        </button> */}
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>

              <div className="mt-4 text-center">
                <p className="mb-0">
                  Wait, I remember my password...{" "}
                  <Link
                    to="/login"
                    className="fw-semibold text-primary text-decoration-underline"
                  >
                    {" "}
                    Click here{" "}
                  </Link>{" "}
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </ParticlesAuth>

  );
};

ForgetPasswordPage.propTypes = {
  history: PropTypes.object,
};

export default withRouter(ForgetPasswordPage);
